export default [
    {
        path: "/training/course/list",
        component: () => import("@/App/Training/Course/Components/List.vue"),
        name: "training-course-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/course/create",
        component: () => import("@/App/Training/Course/Components/Create.vue"),
        name: "training-course-create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/course/:id/edit",
        component: () => import("@/App/Training/Course/Components/Edit.vue"),
        name: "training-course-edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/course/:id/users/create",
        component: () => import("@/App/Training/Course/Components/Users.vue"),
        name: "training-course-users",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/course/:id/users/list",
        component: () => import("@/App/Training/Course/Components/UserTraining.vue"),
        name: "training-course-users-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/course/training",
        component: () => import("@/App/Training/Course/Components/UserTraining.vue"),
        name: "training-course-training",
        meta: {
            requiresAuth: true,
        },
    },
];
